import React from 'react'
import Section from '../Section'
import ExperienceUnit from '../ExperienceUnit'

import safLogo from '../../assets/images/experience/SAF.jpg'
import aibcLogo from '../../assets/images/experience/AIBC.png'
import yaraLogo from '../../assets/images/experience/YARA.png'


class ExperienceSection extends React.Component {
  render() {
    return (
      <Section title="Experience">
        <div className="row">
          <ExperienceUnit
            logo={yaraLogo}
            colour='#FFFFFF'
            title='Yara International, Digital Hub'
            link="https://play.google.com/store/apps/details?id=com.yarafarmweather.farmweather"
            timeperiod='2019-Present'
            subtitle='Collaborated on FarmWeather, a hyperlocal weather TWA app built for smallholder farmers thats leverages on IBM weather api.'
          />
          <ExperienceUnit
            logo={aibcLogo}
            colour='#FFFFFF'
            title='Actionable Insights Brewing Company'
            link="https://antenn.ai"
            timeperiod='2018-2019'
            subtitle='Collaborated on Antenn.ai, an AI powered political lobbying web app/PWA.'
          />
          <ExperienceUnit
            logo={safLogo}
            colour='#FFFFFF'
            title='Singapore Armed Forces'
            link="https://www.linkedin.com/in/abdulhakimsg/"
            timeperiod='2012-2018'
            subtitle='Senior Faculty trainer in Specialist Cadet School.Platoon Sergeant in 3 Guards Battalion'
          />
        </div>
      </Section>
    )
  }
}

export default ExperienceSection



// WEBPACK FOOTER //
// ./src/components/ExperienceSection/index.js